import { coreService } from "../../services/coreService";
import { buildQuery } from "../../lib/network";

export type CrmListFieldDefinitions = Awaited<ReturnType<typeof coreService.crmSearchDemoFieldsList>>["data"]["fields"];
export type ListFieldDefinition = Awaited<
  ReturnType<typeof coreService.crmSearchDemoFieldsList>
>["data"]["customFields"][string];
export type FieldType = ListFieldDefinition["type"];
export type ObjectType = ListFieldDefinition["objectType"];
export type ListFieldPicklist = Exclude<
  Extract<ListFieldDefinition, { type: "Dropdown" | "DropdownMultiSelect" }>["picklist"],
  undefined
>;

export const getCrmListFieldDefinitions = (headers: any) => () => {
  return buildQuery(coreService.crmSearchDemoFieldsList({ headers }), (response) => {
    return response.data;
  });
};
